import scrollIntoView from 'scroll-into-view-if-needed';
import { getNavHeight } from './getNavHeight';

export const scrollIntoViewIfNeeded = (element: HTMLElement | null) => {
  if (!element) return;

  scrollIntoView(element, {
    scrollMode: 'if-needed',
    behavior: actions =>
      actions.forEach(({ el, top }) => {
        if (el.nodeName === 'HTML') top = top - getNavHeight();
        el.scrollTo({ top, behavior: 'smooth' });
      }),
    block: 'start'
  });
};
